import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import { StyledStatusLabel } from './styles';

type Props = {
    isPositive: boolean;
    positiveText: string;
    negativeText: string;
};

const StatusLabel = ({ isPositive, positiveText, negativeText }: Props) => {
    const status = isPositive
        ? { text: positiveText, color: 'var(--success-normal)', icon: <CheckCircleFilled /> }
        : { text: negativeText, color: 'var(--warning-normal)', icon: <WarningFilled /> };

    return (
        <StyledStatusLabel size={4} $color={status.color}>
            {status.icon}
            {status.text}
        </StyledStatusLabel>
    );
};

export default StatusLabel;
